import { SunMark } from "./Logo";

const ITEMS = ["See the person", "Hear the voice", "Honor the journey"];

export default function Marquee() {
  return (
    <div
      className="bg-navy-deep border-y border-gold/25 py-4 sm:py-5 overflow-hidden group"
      data-testid="marquee-band"
    >
      <div className="flex w-max animate-marquee group-hover:[animation-play-state:paused]">
        {[0, 1].map((copy) => (
          <div
            key={copy}
            aria-hidden={copy === 1}
            className="flex shrink-0 items-center"
          >
            {ITEMS.map((t) => (
              <span
                key={t}
                className="flex items-center gap-6 sm:gap-10 px-6 sm:px-10 whitespace-nowrap"
              >
                <SunMark className="w-4 h-4 text-gold/70" />
                <span className="font-serif italic text-gold text-lg sm:text-2xl tracking-wide">
                  {t}
                </span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
